import { Separator } from "@/components/ui/separator.tsx";
import type { ArtifactComponent } from "@/types/artifacts-view.ts";

type DividerComponentData = Extract<ArtifactComponent, { type: "divider" }>;

export const DividerBlock = ({ component }: { component: DividerComponentData }) => {
  // `ArtifactView` already puts a `gap-4` (16px) between every component, so a
  // tight divider adds NO extra margin of its own — its own `my-*` would stack
  // on top of the flex gap and over-space neighbors (e.g. the email subject).
  // Tailwind classes are statically present so the JIT compiler picks them up.
  const className = component.spacing === "tight" ? "" : "my-4";
  return <Separator className={className} />;
};
